import { PermissoesService } from './../../../service/usuario/permissoes.service';
import { RegiaoModel } from 'app/model/endereco/regiao.model';
import { ResponsePageable } from '../../../model/cliente/pageable/responsePageable.model';
import { Component, Input, OnInit, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { ArmazemModel } from 'app/model/endereco/armazem.model';
import { ArmazemService } from 'app/service/endereco/armazem.service';
import { RegiaoService } from 'app/service/endereco/regiao.service';
import { HttpClient } from '@angular/common/http';
import * as CryptoJS from 'crypto-js';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';

@Component({
  selector: 'app-armazem',
  templateUrl: './armazem.component.html',
  styleUrls: ['./armazem.component.scss']
})
export class ArmazemComponent implements OnInit {

  public armazemForm: FormGroup;

  public form: FormGroup;

  public submit = false;

  armazem = {} as ArmazemModel;
  armazems: ArmazemModel[];

  Regiao = {} as RegiaoModel;
  Regioes: RegiaoModel[];
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  @Output() selecionado = new EventEmitter();

  public page: ResponsePageable;

  public message: string = 'Nenhum armazém cadastrado!'

  public pageAtual = 0;

  public edited = false;
  public editado = false;
  public errorAlert = false;
  public successDelete = false;

  user: any;
  creatorArmazem = false;
  editorArmazem = false;
  listaArmazem = false;
  deletaArmazem = false;
  superUser = false;
  arrayString: string;

  mask =  /^\\w+([\\.-]?\\w+)@\\w+([\\.-]?\\w+)(\\.\\w{2,3})+$/;
  ///['(', /[1-9]/, /\d/, ')', ' ', /\d/,/\d/, /\d/, /\d/,/\d/, '-', /\d/, /\d/, /\d/, /\d/] telefone
  //public mask = [ /[1-9]/,' ', /\d/,/\d/, /\d/, /\d/,/\d/, '-', /\d/, /\d/, /\d/, /\d/];

  @ViewChild('cardEdit') targetEl: ElementRef;

  constructor(
    private armazemService: ArmazemService,
    private fb: FormBuilder,
    private _snackBar: MatSnackBar,
    private regiaoService: RegiaoService,
    private permissionService: PermissoesService,
    private http: HttpClient) { }

  ngOnInit() {
    // Formulário de armazém
    this.form = this.fb.group({
      id: [null],
      descricao: [null, [Validators.maxLength(100)]],
      regiao: [null],
      prefixo: [null, [Validators.maxLength(100), Validators.required]],
      cep: [null, [Validators.maxLength(100), Validators.required]],
      logradouro: [null, [Validators.maxLength(100), Validators.required]],
      numero: [null, [Validators.maxLength(100)]],
      bairro: [null, [Validators.maxLength(100), Validators.required]],
      cidade: [null, [Validators.maxLength(100), Validators.required]],
      uf: [null, [Validators.maxLength(2), Validators.required]],
      complemento: [null, [Validators.maxLength(100)]],
      fone: [null, [Validators.maxLength(100), Validators.required]],
      fax: [null, [Validators.maxLength(100)]],
      areaTotal: [null, [Validators.maxLength(100)]],
      areaCirculacao: [null, [Validators.maxLength(100)]],
      areaSeguranca: [null, [Validators.maxLength(100)]],
      areaOperacao: [null, [Validators.maxLength(100)]],
      areaCorredor: [null, [Validators.maxLength(100)]],
      areaUtil: [null, [Validators.maxLength(100)]],
    });

    this.regiaoService.emitirRegiaoCriada.subscribe(data=>{
      this.Regiao = data;
      console.log(this.Regiao);
    });

    this.listPageArmazem(0,10);
    this.regioes();
    this.getAuthority();
  }

  keyPress(event: KeyboardEvent) {
    console.log(event.key);
    var condicional = false;
    var aux = 0;
    oldVal = "";
    if (event.key === '.' || event.key === ',') {
      condicional = true;
      while(event) {
        aux ++;
        if (aux > 2) {

        }
      }
    }
    const pattern = /[0-9]/;
    var inputChar = String.fromCharCode(event.charCode);
    console.log(inputChar);
    var oldVal = '';
    var parts = inputChar.split('.');
    if (parts && parts[1] && parts[1].length > 3) inputChar = oldVal;
    oldVal = inputChar;
    //onkeypress="return String.fromCharCode(event.charCode).match(/[^0-9]/g) === null"
}

  /*limitarNumeros() {
    var input = document.querySelector('input');
    console.log(document.getElementById('areaTotal')!.querySelector<HTMLInputElement>('.form-control')!.value)

    var oldVal = '';
    input.addEventListener('keyup', function(){
        var parts = this.value.split('.');
        if (parts && parts[1] && parts[1].length > 2) {
          this.value = oldVal;
        } else {
          oldVal = this.value;
        }
    });
  }*/

  selecionando(Regiao: any) {
    this.selecionado.emit(Regiao);
  }

  listarArmazems(){
    this.armazemService.getArmazem().subscribe(data => {
      this.armazems = data.content;
    })
  }

  //Mudar paginação
  changePage(event){
    this.listPageArmazem(event.page, event.size);
    this.pageAtual = event.page;
   }

  //Lista de armazens (Paginados)
  listPageArmazem(page, size) {
    this.armazemService.getPageArmazem(page, size).subscribe(res => {
      this.page = res;
      this.armazems = this.page.content;
    });
  }

  scroll() {
    this.targetEl.nativeElement.scrollIntoView();
  }

  //Buscar regiões
  regioes(){
    this.regiaoService.getRegioes().subscribe(data => {
      this.Regioes = data.content;
    })
  }

  //Método para salvar e editar um ARMAZEM
  saveOrUpdateArmazem() {
    console.log(this.armazem);
    if (this.armazem.id !== undefined) {
      this.editArmazem();
    } else {
      this.adicionarArmazem();
    }
    // this.armazem.id = undefined;

  }

  cleanForm(form: NgForm) {
    this.listPageArmazem(0, 10 );
    form.resetForm();
    this.armazem = {} as ArmazemModel;
  }

  adicionarArmazem() {
      this.armazemService.postArmazem(this.form.value).subscribe(result => {

        this.armazem = new ArmazemModel();
        this.openSnackBarSuccess('Armazém salvo com sucesso !');
        this.listPageArmazem(0,10);
        //this.form.get('regiao').setValue('');
        //this.form.get('descricao').setValue('');
        this.postSubmit();
      }, error => {
        console.log(error);
        this.openSnackBarError('Erro ao tentar salvar o Armazém !');
      })
    }

    getDadosUpdate(armazem) {
      console.log(armazem);
      this.armazem = armazem;
      this.form.get('regiao').setValue(armazem.regiao);

    }

    editArmazem() {
      this.armazemService.putArmazem(this.armazem).subscribe(data => {
        this.listPageArmazem(this.pageAtual,10);
        //this.form.get('regiao').setValue('');
        //this.form.get('descricao').setValue('');
        //this.postSubmit();
        this.openSnackBarSuccess('Armazém atualizado com sucesso !');
        this.form.reset();
        this.postSubmit();
      }, err => {
        console.log("Erro: "+ err);
        this.openSnackBarError('Erro ao tentar atualizar o Armazém !');
      });
    }

    onSubmit() {
      this.submit = true;

    }

    setRegiao(regiao, descricaoarmazem){
      const região1 = regiao;
      const descricaoArmazem = descricaoarmazem;
      this.form.get('regiao').setValue(região1);
      this.form.get('descricao').setValue(descricaoArmazem);


    }

    setRegiao2(){
      const regiao2 = { id: 2, descricao: 'Dev'};
      this.form.get('regiao').setValue(regiao2);

    }

    compararRegioes(obj1, obj2) {
      return obj1 && obj2 ? (obj1.descricao === obj2.descricao && obj1.id === obj2.id) : obj1 === obj2;
    }

    postSubmit(){
      this.submit = false;
      this.form.get('regiao').setValue('');
      this.form.get('descricao').setValue('');
      // this.armazem.id = undefined;
      this.form.reset();
    }

  confirmeExclusao(id: number){
    var confirme = confirm("Tem certeza que deseja excluir este armazem ?")
    if(confirme == true){
      this.apagarArmazem(id);
    } else {
      console.log("Cancelou exclusão!");
    }
  }

  apagarArmazem(id: number){
    this.armazemService.deleteArmazem(id).subscribe(armazem => {
        this.armazem = new ArmazemModel();
        this.listPageArmazem(0, 10);
        this.openSnackBarSuccess('Armazém excluído com sucesso !');

    }, error => {
      console.log(error);
      this.openSnackBarError('Erro ao excluir! Este armazém está sendo usado por um cliente.');
    })
  }

  getAuthority() {
    this.getItemAuthority('authority');
    if (this.arrayString.includes('ADD_EMPRESA')) {
      this.creatorArmazem = true;
    }
    if (this.arrayString.includes('EDIT_EMPRESA')) {
      this.editorArmazem = true;
    }
    if (this.arrayString.includes('LIST_EMPRESA')) {
      this.listaArmazem = true;
    }
    if (this.arrayString.includes('DELETE_EMPRESA')) {
      this.deletaArmazem = true;
    }
    if (this.arrayString.includes('SUPER_USER')) {
      this.superUser = true;
    }
  }

  getItemAuthority(key) {
    const store = sessionStorage.getItem(key);
    if (store) {
      try {
        const bytes = CryptoJS.AES.decrypt(
          store,
          sessionStorage.getItem('ticket-ECM')
        );
        this.arrayString = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return this.arrayString;
      } catch (e) {
        sessionStorage.clear();
      }
    }

    return null;
  }

// SnackBares
openSnackBarSuccess(message: string) {
  this._snackBar.open(message, '', {
    horizontalPosition: this.horizontalPosition,
    verticalPosition: this.verticalPosition,
    duration: 4000,
    panelClass: ['success-snackbar']
  });
}

openSnackBarError(message: string) {
  this._snackBar.open(message,'', {
    horizontalPosition: this.horizontalPosition,
    verticalPosition: this.verticalPosition,
    duration: 3000,
    panelClass: ['error-snackbar']
  });
}

   consultaCEP(cep){
    // Nova variável "cep" somente com dígitos.
    cep = cep.replace(/\D/g, '');

    // Verifica se campo cep possui valor informado.
    if (cep !== "") {

      // Expressão regular para validar o CEP.
      var validacep = /^[0-9]{8}$/;

       // Valida o formato do CEP.
       if (validacep.test(cep)) {

        this.http.get(`//viacep.com.br/ws/${cep}/json`)
          .map(dados => dados)
          .subscribe(dados =>  this.populaDadosForm(dados));
       }
    }
  }

  populaDadosForm(dados){
    this.form.get("logradouro").setValue(dados.logradouro)
    this.form.get("bairro").setValue(dados.bairro)
    this.form.get("cidade").setValue(dados.localidade)
    this.form.get("uf").setValue(dados.uf)
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/endereco-components/armazem/armazem.component.ts